import React, { FC, ReactNode } from 'react';
import { OptionProps, Props } from 'react-select';
import styled, { css } from 'styled-components';
import { ItemProps, Item, SelectionVariant } from '@cld/item';
import { globalTheme } from '@cld/component-theme';

export const ListItem = styled(Item)`
  ${(props: { isNew: boolean }) =>
    props.isNew &&
    css`
      border-bottom: 1px solid ${globalTheme.palette.secondaryAlt};
    `};
`;
/**
 * HOC that creates a component to be used as combobox item
 * @param layoutRenderer function that returns react node for given option
 * @param selectionVariant variant of selected state 'solid' | 'subtle'
 */
export const withListItemLayout = <T,>(
  layoutRenderer: (option: T, layoutProps: ItemProps, selectProps: Props<T>) => React.ReactNode,
  selectionVariant: SelectionVariant = 'solid'
): React.FC<OptionProps<T>> => ({ isSelected, isFocused, innerRef, innerProps, data, selectProps }) => {
  const { onClick, ...restInnerProps } = innerProps;

  // FIXME: onClick ListItemLayout is called with no arguments, we should change it to act as normal onClick in the future
  return (
    <ListItem
      /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-member-access */
      isNew={data.__isNew__}
      isHoverable={false}
      selectionVariant={selectionVariant}
      isSelected={isSelected}
      isFocused={isFocused}
      isRounded
      ref={innerRef}
      onClick={onClick as () => void}
      {...restInnerProps}
    >
      {layoutRenderer(data, { isSelected, selectionVariant, showCheckIconWhenSelected: true }, selectProps)}
    </ListItem>
  );
};
